import React, { useEffect, createContext, useContext, useState, ReactNode } from 'react';
import {
  ExportStatusResponse,
  useRequestStartScheduleExport,
  useRequestCheckScheduleStatus,
} from '~/requests';
import { useToastMessage, ToastVariant } from '~/Hooks';
import { useTranslation } from 'react-i18next';

interface ExportContextType {
  startExportSchedule: () => void;
  status: ExportStatusResponse | null;
}

const ExportContext = createContext<ExportContextType | undefined>(undefined);

export const ExportScheduleProvider = ({ children }: { children: ReactNode }) => {
  const [exportUuid, setExportUuid] = useState<string | null>(null);
  const [status, setStatus] = useState<ExportStatusResponse | null>(null);

  const { t } = useTranslation();
  const { showToast } = useToastMessage();
  const { mutate: startSchedule, data: startResponse } = useRequestStartScheduleExport();
  const startExportSchedule = () => {
    setStatus(null);
    startSchedule();
  };
  const { refetch, data: statusResponse } = useRequestCheckScheduleStatus();

  useEffect(() => {
    if (startResponse?.length) {
      setExportUuid(startResponse);
    }
  }, [startResponse]);

  useEffect(() => {
    //trigger check status
    refetch(exportUuid || '');
  }, [exportUuid?.length]);

  useEffect(() => {
    if (statusResponse?.status) {
      setStatus(statusResponse);
    }
  }, [statusResponse]);

  useEffect(() => {
    if (!!status?.downloadLink?.length) {
      const content = (
        <div>
          {`${t('app.download.ready')}: `}
          <a
            href={status.downloadLink}
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => {
              if (status?.downloadLink) {
                window.open(status.downloadLink, '_blank');
              }
            }}
          >
            {t('app.download')}
          </a>
        </div>
      );
      showToast('app.download.ready', content, ToastVariant.SUCCESS, false, undefined, 15000);
    }
  }, [status?.downloadLink]);

  return (
    <ExportContext.Provider value={{ startExportSchedule, status }}>
      {children}
    </ExportContext.Provider>
  );
};
export const useExportContext = (): ExportContextType => {
  const context = useContext(ExportContext);
  if (!context) {
    return {
      status: null,
      startExportSchedule: () => {},
    };
  }
  return context;
};
